export const SPACE_GIF = new Image();
SPACE_GIF.src = require("./space.gif");

export const GIFT_IMG = new Image();
GIFT_IMG.src = require("./gift.png");

export const QUESTION_IMG = new Image();
QUESTION_IMG.src = require("./question.png");
